// src/models/Company.js

class Sucursal {
    constructor({
      id = null,
      name = '',
  
      address = '',
      phone_number = '',
      email = '',
    
    }) {
      this.id = id;
      this.name = name;
    
      this.address = address;
      this.phone_number = phone_number;
      this.email = email;
     
    }
  
    // Método para actualizar los datos de la empresa
    update(data) {
      Object.assign(this, data);
    }
  }
  
  export default Sucursal;
  